import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { ProductOverviewChargeStatic } from "./ProductOverviewChargeStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const ProductOverviewChargeDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ProductOverviewChargeStore: ProductOverviewChargeStatic = new ProductOverviewChargeStatic();
export const ProductOverviewProductInformationDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
